import React from "react";
import { Redirect } from "react-router-dom";
import Login from "../pages/Authentication/Login";
import Dashboard from "../pages/Dashboard/Dashboard";
import UserList from "../pages/Administration/Users/UserList";
import UserAdd from "../pages/Administration/Users/UserAdd";
import UserAddPublic from "../pages/Administration/Users/UserAddPublic";
import UserEdit from "../pages/Administration/Users/UserEdit";
import UserPermissions from "../pages/Administration/Users/UserPermissions";
import UserProfile from "../pages/Administration/Users/UserProfile";
import UserChangePassword from "../pages/Administration/Users/ChangePassword";
import QRGenerator from "../pages/Administration/Users/QRGenerator";
import AgentAssign from "../pages/Roles/AgentAssign";
import RolUpdate from "../pages/Roles/RolUpdate";
import RolCreate from "../pages/Roles/RolCreate";
import PermissionAssign from "../pages/Roles/PermissionAssign";
//Contacts
import ContactsIndex from "../pages/Contacts";
import Contact from "../pages/Contacts/Contact";
import ContactsCreate from "../pages/Contacts/ContactAdd";
import CompanyCreate from "../pages/Contacts/CompanyAdd"
import ProfileTab from "../pages/Contacts/components/ProfileTab";

//Gestion contacto 
import CalificacionContacto from "../pages/CalificaciónContacto/CalificacionContcacto"
import DescripcionCalificacion from "../pages/DescripcionCalificacion/DescripcionCalificacion"
import CalificacionContactoAdd from "../pages/CalificaciónContacto/CalificacionContactoAdd"
import DescripcionCalificacionAdd from "../pages/DescripcionCalificacion/DescripcionCalificacionAdd"
import GestionContacto from "../pages/GestionContacto/GestionContacto";
import GestionContactoCreate from "../pages/GestionContacto/GestionContactoCreate"
//Account
import Account from "../pages/Account/Account";
import AccountCreate from "../pages/Account/AccountCreate";
import AccountUpdate from "../pages/Account/AccountUpdate";
// Campaigns
import Campaign from "../pages/Campaign/Campaign";
import CampaignCreate from "../pages/Campaign/CampaignCreate";
import CampaignUpdate from "../pages/Campaign/CampaignUpdate";


//Casos
import Casos from "../pages/Casos/Casos";
import CasosCreate from "../pages/Casos/CasosCreate";
import CasosUpdate from "../pages/Casos/CasosUpdate";
import CasosDetails from "../pages/Casos/CasosDetails";
import ActaVisitaPage from "../pages/Casos/ActaVisitaPage";

//Error
import Error404 from "../pages/Error/Error404"

// Rutas Publicas
import Prueba from "../pages/Public/Prueba"

import Audits from "../pages/Audits/AuditsList"
import TipoGestionContacto from "../pages/TipoGestionContacto/TipoGestionContacto";
import TipoGestionContactoAdd from "../pages/TipoGestionContacto/TipoGestionContactoAdd";


//Whatsaap
import { Index } from "../pages/Whatsapp/Index";
import ManagementList from "../pages/GestionContacto/ManagementList";
import Reports from "../pages/Reports/Reports"
import ReportsWhatsapp from "../pages/Reports/ReportsWhatsapp"
import ReportsForHour from "../pages/Reports/ReportsForHour";
import ReportSupervisor from "../pages/Reports/ReportSupervisor";
import ReportsBot from "../pages/Reports/ReportsBot";
import ReportForTime from "../pages/Reports/ReportForTime";
import ReportLead from "../pages/Reports/ReportLead";
import ReporteAgentes from "../pages/Reportes/ReporteAgentes";
import ReporteActas from "../pages/Reportes/ReporteActas";

import LandingPage from "../pages/LandingPage/LandingPage";
import ContactsGroups from "../pages/ContactsGroups/ContactsGroups";
import ReportTypifications from "../pages/Reports/ReportTypifications";
import ModuleList from "../pages/Administration/Modules/Modules";
import SessionHistory from "../pages/Administration/SessionHistory/SessionHistory";
import AvailabilityForm from "../pages/Campaign/Availability/AvailabilityForm";
import Typifications from "../pages/Typifications/components/Typifications";
//import Typifications from "../pages/Campaign/Typifications";
import AvailabilityFormContact from "../pages/Contacts/Availability/AvailabilityForm";
import AppointmentSetup from "../pages/AppointmentScheduler/AppointmentSetup";
import UploadDashboard from "../pages/FilesLoad/UploadDashboard";
import DiagramModule from "../pages/DiagramModule/DiagramModule";
import Tarifas from "../pages/Parametrizacion/Tarifas/Tarifas";
import Recipientes from "../pages/Parametrizacion/Recipientes/Recipientes";
import ActividadesEconomicas from "../pages/Parametrizacion/ActividadesEconomicas/ActividadesEconomicas";
import ArchivosActas from "../pages/ArchivosActas/ArchivosActas";
import GaleriaImagenes from "../pages/GaleriaImagenes/GaleriaImagenes";
import DescargaArchivos from "../pages/DescargaArchivos/DescargaArchivos";
import ServiciosAdicionalesDashboard from "../pages/ServiciosAdicionales/ServiciosAdicionalesDashboard";

const publicRoutes = [
  { path: "/prueba", component: Prueba },
];

const authRoutes = [
  { path: "/login", component: Login },
  { path: "/users/add_user2", component: UserAddPublic },
  { path: "/landingPage", component: LandingPage },

];

const allRoutes = [
  { path: "/dashboard", component: Dashboard },
  { path: "/users", component: UserList },
  { path: "/users/qr-generator", component: QRGenerator },
  { path: "/users/add_user", component: UserAdd },
  { path: "/users/:id/edit_user", component: UserEdit },
  { path: "/userProfile", component: UserProfile },
  { path: "/modules", component: ModuleList },
  { path: "/changePassword", component: UserChangePassword },
  { path: "/sessionList/:id", component: SessionHistory },
  { path: "/audits", component: Audits },
  { path: "/users/permission_assign/:id", component: UserPermissions },
  { path: "/rol/permission_assign/:id", component: PermissionAssign },
  { path: "/rol/add_rol", component: RolCreate },
  { path: "/rol/agent_assign", component: AgentAssign },
  { path: "/rol/update_rol/:id", component: RolUpdate },
  { path: "/contact/add_contact", component: ContactsCreate },
  { path: "/contact/add_company", component: CompanyCreate },
  { path: "/contacts/:id/index", component: ContactsIndex },
  { path: "/contacts", component: Contact },
  { path: "/contact/:id/contact_profile", component: ProfileTab },
  { path: "/availabilityContact/:id", component: AvailabilityFormContact },
  { path: "/account", component: Account },
  { path: "/account/create", component: AccountCreate },
  { path: "/account/update/:id", component: AccountUpdate },
  { path: "/campaign", component: Campaign },
  { path: "/campaign/create", component: CampaignCreate },
  { path: "/campaign/update/:id", component: CampaignUpdate },
  { path: "/campaign/availability/:id", component: AvailabilityForm },

  { path: "/descripcionCalificacion", component: DescripcionCalificacion },
  { path: "/calificacionContacto", component: CalificacionContacto },
  { path: "/descripcionCalificacion/add_descripcion", component: DescripcionCalificacionAdd },
  { path: "/calificacionContacto/add_calificacion", component: CalificacionContactoAdd },
  { path: "/casos", component: Casos },
  { path: "/casos/create", component: CasosCreate },
  { path: "/casos/update/:id", component: CasosUpdate },
  { path: "/casos/view/:id", component: CasosDetails },
  { path: "/casos/:id/acta-visita", component: ActaVisitaPage },
  { path: "/chat/:id", component: Index },
  { path: "/chat/", component: Index },
  { path: "/tipoGestionContacto", component: TipoGestionContacto },
  { path: "/tipoGestionContacto/add_tipoGestion", component: TipoGestionContactoAdd },
  { path: "/gestionContactoCreate/:id", component: GestionContactoCreate },
  { path: "/gestionContacto/:id", component: GestionContacto },
  { path: "/managementList", component: ManagementList },
  { path: "/report_for_hour", component: ReportsForHour },
  { path: "/report_for_bot", component: ReportsBot },
  { path: "/report_for_time", component: ReportForTime },
  { path: "/report_supervision", component: ReportSupervisor },
  { path: "/report_type", component: ReportTypifications },
  { path: "/reports", component: Reports },
  { path: "/reports/whatsapp", component: ReportsWhatsapp },
  { path: "/reports/leads", component: ReportLead },
  { path: "/reportes-agentes", component: ReporteAgentes },
  { path: "/reportes-actas", component: ReporteActas },
  { path: "/contactsGroups", component: ContactsGroups },
  { path: "/typification", component: Typifications },
  { path: "/agenda", component: AppointmentSetup },
  { path: "/upLoad-dashboard", component: UploadDashboard },
  { path: "/flow-chart", component: DiagramModule },
  { path: "/parametrizacion/tarifas", component: Tarifas },
  { path: "/parametrizacion/recipientes", component: Recipientes },
  { path: "/parametrizacion/actividades-economicas", component: ActividadesEconomicas },
  { path: "/archivos-actas", component: ArchivosActas },
  { path: "/galeria-imagenes", component: GaleriaImagenes },
  { path: "/descargar-archivos", component: DescargaArchivos },
  { path: "/servicios-adicionales", component: ServiciosAdicionalesDashboard },


  // this route should be at the end of all other routes
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
  { path: "*", component: Error404 },

];

export { publicRoutes, allRoutes, authRoutes };
